
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transaction-history",
      function () {
        return require("private-next-pages/transaction-history.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transaction-history"])
      });
    }
  